export const GOOGLE_MAP_API_KEY = 'AIzaSyA1MQX6oOpJLr3nk6imF-gtjySkZuwvh7o';
